import { render, staticRenderFns } from "./Contrato_Renovaciones.vue?vue&type=template&id=2db1421d&scoped=true&"
import script from "./Contrato_Renovaciones.vue?vue&type=script&lang=js&"
export * from "./Contrato_Renovaciones.vue?vue&type=script&lang=js&"
import style0 from "./Contrato_Renovaciones.vue?vue&type=style&index=0&id=2db1421d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db1421d",
  null
  
)

export default component.exports